/* Small enhancements only. Shopify Dawn owns product, search, menu and cart. */
(() => {
  function initialize(root = document) {
    // Carry a product inquiry into the native Shopify contact form. No storage,
    // trackers, buyer identifiers, or third-party requests are created here.
    const input = root.querySelector('#ContactForm-body');
    const product = new URLSearchParams(location.search).get('product');
    if (input && product && !input.value.trim()) {
      input.value = `I'd like to ask about ${product.slice(0, 200)}.\n\n`;
    }
    // Reveal the selected FAQ when the merchant selects its block in the editor.
    root.querySelectorAll('.cvf-faq__item').forEach((details) => {
      if (details.dataset.cvfReady) return;
      details.dataset.cvfReady = 'true';
      details.addEventListener('shopify:block:select', () => { details.open = true; });
    });
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
